export default __webpack_public_path__ + "static/media/chevron-right.e32b5092.svg";